import { render, staticRenderFns } from "./TypeMailSelector.vue?vue&type=template&id=b648781a&"
import script from "./TypeMailSelector.vue?vue&type=script&lang=js&"
export * from "./TypeMailSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports